import { OnboardingInternalRouteBlocker } from '@cash-web/protos/squareup/franklin/blockers/onboarding_internal_route_blocker.pb'
import { useQueryOnboardingInternalRoute } from '@cash-web/shared-data-access-api/react-query'
import { useLoadUrl } from '@cash-web/shared-data-access-load-url'
import { useJourneyContext } from '@cash-web/shared-journey-data-access-context'

import { BlockerLoading } from '../BlockerLoading/BlockerLoading'

export const BlockerOnboardingInternalRoute = ({ blocker }: { blocker: OnboardingInternalRouteBlocker }) => {
  const journey = useJourneyContext()
  const loadUrl = useLoadUrl()
  // we must fetch the internal route before we can update the flow
  // this is because the flow will not proceed until the internal route is fetched
  useQueryOnboardingInternalRoute({
    variables: {
      child_flow_type: blocker.child_flow_type,
      encoded_flow_params: blocker.encoded_flow_params,
      flow_token: blocker.flow_token,
      request_context: {
        blocker_descriptor_id: 'ONBOARDING_INTERNAL_ROUTE_BLOCKER',
      },
    },
    queryOptions: {
      onSuccess: data => {
        if (data?.internal_navigation_url != null) {
          loadUrl({ url: data?.internal_navigation_url, options: { scope: { target: 'outlet:login' } } })
        }
      },
      onError: error => {
        journey.navigate('/dl/view/error/default')
      },
    },
  })
  return <BlockerLoading />
}
